export enum TeachingBubblesTypes {
    fileMultipleEmail = "fileMultipleEmail",
    filesTransfer = "filesTransfer",
    forwardReviewRfi = "forwardReviewRfi",
    forwardReviewSubmittal = "forwardReviewSubmittal",
    respondAndCloseRfi = "respondAndCloseRfi",
    respondAndCloseSubmittal = "respondAndCloseSubmittal",
    projectItem = "projectItem",
}
